import { isNil } from 'lodash-es';
import { SdsTreeNode } from './sds-tree-node.lit';
/**
 * Calculates the total column count with an offset.
 * @param {number} base - The base number of columns.
 * @returns {number} The total column count with the offset applied.
 */
export function colCountWithOffset(base) {
    return base + 3;
}
/**
 * Finds the closest 'sds-tree' element in the DOM hierarchy, starting from the given element.
 * @param {HTMLElement} element - The starting element for the search.
 * @returns {SdsTree | undefined} The closest 'sds-tree' element if found, undefined otherwise.
 */
export function findTree(element) {
    return findAncestor(element, 'sds-tree');
}
/**
 * Finds the closest ancestor element with the given selector.
 * @param element
 * @param selector
 */
export function findAncestor(element, selector) {
    if (element.isConnected) {
        const ancestor = element.closest(selector);
        if (isNil(ancestor)) {
            console.error(`Could not find findAncestor element with selector '${selector}'`);
            return undefined;
        }
        else {
            return ancestor;
        }
    }
    else {
        console.warn('Element is not yet connected to the DOM');
        return undefined;
    }
}
export function getMaxFirstColumnSize(nodes) {
    let maxSize = 0;
    nodes.forEach((node) => {
        maxSize = Math.max(maxSize, node.isCollapsed || node.isLeaf
            ? node.firstColumnSizeBeforeExpand
            : node.firstColumnSizeAfterExpand);
        if (node.isCollapsed || node.isLeaf)
            return;
        const childNodes = Array.from(node.children).filter(item => item instanceof SdsTreeNode);
        maxSize = Math.max(maxSize, getMaxFirstColumnSize(childNodes));
    });
    return maxSize;
}
